import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AvantoModalControlService {

  constructor() {}

  //---------------- TOGGLE CART SUBJECT -----------------\\
  //The component that controls the cart modal will 
  //subscribe to this variable and be notified everytime  
  //another component wants to open/close the cart sidebar!
  toggleCartSidebarSubject = new Subject<boolean>();
  openOrderDetailsModalSubject = new BehaviorSubject<{showOrderType:boolean, showOrderTime:boolean, showAddressChange:boolean}>(null);

  openCartModal(){
    this.toggleCartSidebarSubject.next(true);
  }
  closeCartModal(){
    this.toggleCartSidebarSubject.next(false);
  }
  openOrderDetailsModal(showOrderTypeSelection, showOrderTimeSelection, showAddressChangeSelection){
    this.openOrderDetailsModalSubject.next({
      showOrderType:showOrderTypeSelection, 
      showOrderTime:showOrderTimeSelection, 
      showAddressChange:showAddressChangeSelection
    });
  }
}
